import { Injectable } from '@angular/core';

import { ApiClientService } from './util/api.client.service';

declare var $: any;

@Injectable()
export class NotificationService {
    unreadNotifications: any[] = [];
    constructor(private http: ApiClientService) { }

    readNotifications(noticeId: any) {
        return this.http.put('/notice/read/' + noticeId, {});
    }
    getNotifications(page: any, size: any) {
        return this.http.get('/notice?page=' + page + '&size=' + size);
    }
    getMyNotifications(page: any, size: any) {
        return this.http.get('/my/notifications?page=' + page + '&size=' + size);
    }
    getUnreadNotifications() {
        return this.http.get('/noticeUnread');
    }
    setUnreadNotificationsCount(value: any) {
        this.unreadNotifications = value;
    }
    setUnreadNotificationsCountAlert(value: any) {
        this.unreadNotifications = value;
        if (this.unreadNotifications.length > 0) {
            value.forEach((notification: any) => {
                this.notify(notification);
            });
        }
    }
    notify(notification: any) {
        $.notify({
            title: notification.color,
            message: notification.notificationTitle,
            url: '/#/notifications',
        },
            {
                timer: 2000,
                placement: {
                    from: 'top',
                    align: 'right'
                },
                animate: {
                    enter: 'animated fadeInRight',
                    exit: 'animated fadeOutRight'
                },
                template:
                    '<div data-notify="container" class="col-xs-11 col-sm-3 alert st-alert" style="border-left: 5px solid {1}" role="alert">' +
                    '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' +
                    '<span data-notify="title" class="title-notification">{2}</span> ' +
                    '<a href="{3}" data-notify="url"></a>' +
                    '</div>'
            });
    }
    getUnreadNotificationsCount() {
        return this.unreadNotifications;
    }
    getDetaillNotifications(noticeId: any){
        return this.http.get('/notice/data/' + noticeId, {});
    }
    getDownloadFiles(documentId:any) {
        return this.http.get('/notification/document/'+ documentId, { secure: true });
    }
    getDetaillMyNotifications(notificationId: any) {
        return this.http.get('/data/notification/' + notificationId  , { secure: true });
    }
    sendNotifications(notifications: any , noticeType: any) {
        return this.http.post('/create/notice/'+ noticeType, notifications, { secure: true });
    }
    postCreateResponse (noticeId:number , body:any) {
        return this.http.post('/create/response/' + noticeId, body, { secure: true });
    }
    getAllMyNotificationsByFilters(search:any){
        return this.http.get('/my/notification/advance'+ search, { secure: true }); 
    }

    getUnreadNoticeSchoolTransfer() {
        return this.http.get('/noticeUnread/school-transfer', {secure: true})
    }

    changeStatusSchoolTransfer() {
        return this.http.put('/notice/read/school-transfer',{} ,{secure: true})
    }
}




// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/notification.service.ts